import { axiosService } from '../.';

export default class UpdateOrganizationBusinessUrlQrPageRedirectsTo {
    public async execute(input: UpdateOrganizationBusinessUrlQrPageRedirectsToDto): Promise<void> {
        await axiosService.instance.post(`businesses/organization/update-url-qr-code-redirects-to`, { ...input });
    }
}

export class UpdateOrganizationBusinessUrlQrPageRedirectsToDto {
    private businessId: number;
    private consumerId: number;
    private urlQrPageRedirectsTo: string;

    constructor(businessId: number, consumerId: number, urlQrPageRedirectsTo: string) {
        this.businessId = businessId;
        this.consumerId = consumerId;
        this.urlQrPageRedirectsTo = urlQrPageRedirectsTo;
    }
}

export const updateOrganizationBusinessUrlQrPageRedirectsTo = new UpdateOrganizationBusinessUrlQrPageRedirectsTo();
